import styled from 'styled-components';

import { BasicParagraph } from '@genially/design-system';

export const Wrapper = styled.div(({ theme: { color, size } }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: size.units(1),
  cursor: 'pointer',
  padding: `${size.units(1.25)} ${size.units(2)}`,
  borderRadius: size.units(0.5),

  '&:hover': {
    backgroundColor: color.background.primary.hover(),
  },
}));

export const StyledIcon = styled.span(({ theme: { color, size } }) => ({
  width: size.units(2),
  height: size.units(2),
  minWidth: size.units(2),
  minHeight: size.units(2),
  color: color.content.secondary.default(),
  flexShrink: 0,
}));

export const Label = styled(BasicParagraph)(({ theme: { color } }) => ({
  color: color.content.secondary.default(),
  flex: 1,
}));
